import { render, staticRenderFns } from "./MerchantUserDetails.vue?vue&type=template&id=4fc94110&scoped=true"
import script from "./MerchantUserDetails.vue?vue&type=script&lang=js"
export * from "./MerchantUserDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc94110",
  null
  
)

export default component.exports